import React, { useEffect, useState } from 'react';
import './photo_video_instruction.css';
import { useNavigate, useParams } from 'react-router-dom';

const Photo_Video_Instruction = ({setShowInstructionPage}) => {
  const landscape = `${process.env.PUBLIC_URL}/inspection-icons/landscapeMode.svg`;
  const clock_icon = `${process.env.PUBLIC_URL}/custom-icons/intro.gif`;
  const navigate = useNavigate();
  const { audit_id } = useParams();

  // Initialize state based on window dimensions (Landscape or Portrait)
  const [isInLandscapeMode, setIsInLandscapeMode] = useState(
    window.innerWidth > window.innerHeight
  );

  useEffect(() => {
    // Function to update orientation
    const updateOrientation = () => {
      setIsInLandscapeMode(window.innerWidth > window.innerHeight);
    };

    // Add event listener to detect orientation change
    window.addEventListener('resize', updateOrientation);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', updateOrientation);
    };
  }, []);

  return (
    <>
      {!isInLandscapeMode ? (
        <div
          style={{
            opacity: '0.8',
            height: '100svh',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <img
            src={landscape}
            alt="Landscape GIF"
            style={{
              height: '4rem',
            }}
          />
          <h3
            style={{
              textAlign: 'center',
              marginBottom: '0.5rem',
              wordWrap: 'break-word',
            }}
          >
            Please rotate video to landscape
          </h3>
          <h6
            style={{
              padding: '0 1rem',
              textAlign: 'center',
              wordWrap: 'break-word',
            }}
          >
            Turn on auto-rotation as video needs to be captured in landscape
            mode.
          </h6>
        </div>
      ) : (
        <div className="container">
          {/* <div className="video-example">
            <video className="video-player" controls>
              <source src={clock_icon} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div> */}
          <div className="instructions">
            <h2 className="title">Video instruction</h2>
          
            <ul className="step-list">
              <li className="step">
                <div className="step-number">1</div>
                <p className="step-text">
                Turn off the vehicle (if it's on)
                </p>
              </li>
              <li className="step">
                <div className="step-number">2</div>
                <p className="step-text">Start recording, focus on the RPM gauge</p>
              </li>
              <li className="step">
                <div className="step-number expand-icon">3</div>
                <p className="step-text">Turn on the ignition and keep the 
                camera on the RPM for 5-10 sec</p>
              </li>
              {/* <li className="step">
                <div className="step-number">4</div>
                <p className="step-text">Exit the vehicle, continuing to record</p>
              </li>
              <li className="step">
                <div className="step-number expand-icon">5</div>
                <p className="step-text">Capture a 360-degree view by 
                walking around the car for 1 minute.</p>
              </li> */}
            </ul>
            <button
              className="skip-button"
              onClick={() => setShowInstructionPage(false)} 
            >
              Next
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Photo_Video_Instruction;
